export default __webpack_public_path__ + "static/media/ClientDetails.4a7410eb.svg";